import { AnimatePresence, motion } from "framer-motion"
import { mainMenu } from "../../utils/myData";
import { useNavigate } from "react-router-dom";
import { item_listAnimation, listAnimation } from "../../Variables";

export const NavbarCustom = ({ isOpen, isMobile, setIsOpen }) => {

    const navigate = useNavigate();

    const handleClick = (link) => {
        setIsOpen(false);
        return navigate(`/${link}`)
    }

    return (
        
        <AnimatePresence initial={false} mode="wait">
            { isOpen ? 
                <motion.div 
                    className={`z-10 bg-black lg:w-[700px] w-96 fixed right-0 top-0 h-screen`}
                    initial={{  translateX: isMobile ? 100: 200 }}
                    animate={{ translateX: isMobile ? 0 : 20 }}
                    exit={{ translateX: isMobile ? 100 : 700 }}

                    transition={{ type:"spring", duration:0.5, ease:"easeIn"}}
                >
                    <nav className="pl-24 h-full flex items-start pt-48 relative">
                        <motion.ul 
                            className={`flex flex-col gap-4`}
                            variants={listAnimation}
                            initial="hidden"  
                            animate={isOpen && "show"} 
                        >
                            {mainMenu?.map(item => 
                                <motion.li 
                                    key={item.id} 
                                    className={`text-slate-300 lg:text-xl text-2xl ${item.id === 6 ? "absolute left-24 bottom-32" : ""}`}
                                    variants={item_listAnimation} 
                                    whileTap={{ scale:1.045 }}
                                    whileHover={{ scale:1.045 }}

                                    transition={{ type:"spring", stiffness:200, ddamping:10, ease:"easeInOut"}}
                                >
                                    <button onClick={() => handleClick(item.redirect_to) } className={item.id === 6 && "text-orange-400"}>{ item.title }</button>
                                </motion.li>
                            )}
                        </motion.ul>
                    </nav>
                </motion.div>
                :
                null
            }
            
        </AnimatePresence> 
    )
}